import NodeExpansionItemAdder from "./NodeExpansionItemAdder";
import NodeInsertionPanel from "./NodeInsertionPanel";
import TemplatePositionLock from "./TemplatePositionLock";
import RegionOutlineVisiblityGrid from "./RegionOutlineVisiblityGrid";
import ScalebarMenu from "./ScalebarMenu";
import CropIcon from '@material-ui/icons/Crop';
import ChooseCropIcon from './ChooseCropIcon';
import AddIcon from '@material-ui/icons/Add';
import SubregionOutlineMenu from "./SubregionOutlineMenu";

const menuItemToActionMap = {
  editRegion:"specifyExpansionNodeRegion",
}
const menuItemToTitleMap = {
  setImageResolution:(
    <div>Set image resolution</div>
  ),

  addItems:{
  },

  editRegion:(
    <div class="sg-row v-center">
      {false && <CropIcon style={{color:'#666'}}/>}
      <span>Insert image</span>
    </div>
  ),
  setRegionVariable:(
    <div class="sg-row v-center">
      <ChooseCropIcon style={{color:'#666'}}/>
      <span style={{paddingLeft:5}}>Choose region</span>
    </div>
  )
}

export default function getMenuItems({
  possibleActions,
  unifiedGroup,
  onEvent,

}){



  let urgentActions;
  let menuItems;




  urgentActions = Object.entries(possibleActions||{}).filter(([key,value]) => value?.urgent)

  if( urgentActions.length > 0 ){


    menuItems = urgentActions.map(([key,value]) => {
      let type = (menuItemToActionMap[key] || key)
      return {
        type,
        action:type,
        title:(menuItemToTitleMap[key]||type),
        args:value,
      }
    })

  }else{


    let isRegionNode = unifiedGroup?.type === "region";

    let regionId = unifiedGroup?.value?.regionId;


    if( isRegionNode && regionId ){

      menuItems = [

        /*{
          action:"regionOutlineEdit",
          type:"regionOutlineEdit",
          ignore:true,
          title:"Region Outline(s)",
          submenu:[
            {
              action:"regionOutlineGrid",
              type:"grid",
              ignore:'true',
              //title:"This is where you'd toggle visibility of all region outlines."
              title:(
                <RegionOutlineVisiblityGrid/>
              )
            }
          ]
        },*/


        {
          action:"specifyExpansionNodeRegion",
          type:"specifyExpansionNodeRegion",
          title:"Edit region"
        },

        {
          type:"insert",
          ignore:true,
          action:"insert",
          title:(
            <div class="sg-row v-center">
              <AddIcon style={{fontSize:16}}/>
              &nbsp;
              Insert
            </div>
          ),

          submenu:[

            {
              hoverable:false,
                _id:Math.random(),
                type:"insertionLocation",
                action:"insertionLocation",
                ignore:true,
                title:(
                  <NodeExpansionItemAdder onEvent={onEvent}/>
                ),

              },
            /*{
              type:"bla",
              action:"add",
              args:{},
              title:(
                <NodeExpansionItemAdder/>
              )
            },*/
          ]
        }]
    }else if( isRegionNode && !regionId ){
      menuItems = [{
        type:"setChannel",
        action:"setChannel",
        title:"Set channel image",
      }]
    }else{
      if( unifiedGroup?.type === "scalebar" ){
        debugger;
        menuItems = [
          /*{
            type:"scalebar",
            title:"Extra option"
          },*/
          {
            type:"scalebar",
            action:"scalebar",
            ignore:true,
            title:"Scalebar",
            submenu:[
              { 
                hoverable:false,
                type:"editScalebar", 
                action:"editscalebar",
                ignore:true,
                title:(
                  <ScalebarMenu 
                    onEvent={onEvent}
                    data={unifiedGroup}/>
                )
              }
            ]
          }
        ]
      }else if( unifiedGroup?.type === "regionOutline" ){

        menuItems = [
          {
            type:"regionOutline",
            action:"regionOutline",
            ignore:true,
            hoverable:false,

            title:(
              <SubregionOutlineMenu onEvent={onEvent} 
                //figurePanelId={figurePanelId}
                //selectedFigureItems={selectedItems}
                data={unifiedGroup}/>
            )
          }
        ]
      }
    }
  }

  return menuItems;
}
